//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('equipmentGrpMenu', {
//        templateUrl: 'views/components/views/equipmentGrpMenu/equipmentGrpMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'equipmentGrpMenuService', function ($stateParams, stateService, equipmentGrpMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let equipmentGrpId = $stateParams.equipmentgrp_id;

//            vm.model = {
//                equipmentGroupNameButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('equipmentgrplang', { equipmentgrp_id: vm.model.menu.equipmentgrp_id }) }
//                ],
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await equipmentGrpMenuService.getMenu({ equipmentgrp_id: equipmentGrpId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
